import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "divide-y divide-gray-200" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-6 mt-6 md:grid-cols-3" }
const _hoisted_5 = { class: "col-span-1 sm:col-span-1" }
const _hoisted_6 = {
  class: "block text-sm font-medium text-gray-700",
  for: "gender"
}
const _hoisted_7 = { class: "col-span-1 sm:col-span-1" }
const _hoisted_8 = { class: "col-span-1 sm:col-span-1" }
const _hoisted_9 = { class: "col-span-1 sm:col-span-1" }
const _hoisted_10 = {
  class: "block text-sm font-medium text-gray-700",
  for: "ageRange"
}
const _hoisted_11 = { class: "col-span-1 sm:col-span-1" }
const _hoisted_12 = { class: "col-span-1 sm:col-span-1" }
const _hoisted_13 = { class: "col-span-1 sm:col-span-1" }
const _hoisted_14 = { class: "mt-6" }
const _hoisted_15 = { class: "px-6 pb-6 bg-clay-50 divide-y divide-clay-200" }
const _hoisted_16 = { class: "max-w-2xl pt-6 font-bold text-clay-900" }
const _hoisted_17 = { class: "mt-6" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "space-y-5" }
const _hoisted_20 = { class: "grid gap-1 sm:grid-cols-2 md:grid-cols-3" }
const _hoisted_21 = { class: "relative flex items-start" }
const _hoisted_22 = { class: "flex items-center h-5" }
const _hoisted_23 = ["id", "name", "value"]
const _hoisted_24 = { class: "ml-3 text-sm" }
const _hoisted_25 = ["for"]
const _hoisted_26 = { class: "py-3 mt-10 text-center" }

import {computed, defineComponent, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {GetProfileAppearance, GetProfileAppearanceResponse, UpdateProfileAppearance} from "@/dtos";
// @ts-ignore
import {SparklesIcon, TrashIcon} from '@heroicons/vue/20/solid';
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SaCombobox from "@/main/components/SaCombobox.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateProfileAppearance',
  setup(__props) {

// @ts-ignore
const heightFeetOptions = ref([
    '3', '4', '5', '6', '7'
]);

const heightInchesOptions = ref([
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'
]);

const responseStatus = ref(null);
const profile: Ref<GetProfileAppearanceResponse> = ref(new GetProfileAppearanceResponse());

const getProfileAppearance = async () => {
    await client.get<GetProfileAppearanceResponse>(new GetProfileAppearance())
        .then(response => {
            profile.value = response;
            profile.value.heightFeet = profile.value.heightFeet === '0' ? '' : profile.value.heightFeet;
            profile.value.heightInches = profile.value.heightInches === '0' ? '' : profile.value.heightInches;
            isFetching.value = false;
        });
}

const isFetching = ref(true);
onMounted(async () => {
    await getProfileAppearance();
});

const isSubmitting = ref(false);
const updateSuccessful: Ref<Boolean> = ref(false);
const submit = async () => {
    isSubmitting.value = true;
    let request = profile.value;
    await client.post<ResponseStatus>(new UpdateProfileAppearance(request))
        .then(_ => {
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isFetching.value)
      ? (_openBlock(), _createBlock(SkeletonCard, {
          key: 0,
          class: "mt-4",
          "card-style": "long",
          "num-of-cards": 1
        }))
      : (_openBlock(), _createElementBlock("form", _hoisted_1, [
          _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, [
                    _cache[8] || (_cache[8] = _createTextVNode("Gender ")),
                    _createVNode(_unref(SparklesIcon), { class: "inline w-4 h-4 mx-1 text-powder-600" })
                  ]),
                  _createVNode(SaCombobox, {
                    id: "gender",
                    modelValue: profile.value.gender,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profile.value.gender) = $event)),
                    options: profile.value.genderOptions,
                    name: "gender"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", {
                    class: "block text-sm font-medium text-gray-700",
                    for: "heightFeet"
                  }, "Height (feet) ", -1)),
                  _createVNode(SaCombobox, {
                    id: "heightFeet",
                    modelValue: profile.value.heightFeet,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profile.value.heightFeet) = $event)),
                    options: heightFeetOptions.value,
                    name: "heightFeet"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", {
                    class: "block text-sm font-medium text-gray-700",
                    for: "heightInches"
                  }, "Height (inches) ", -1)),
                  _createVNode(SaCombobox, {
                    id: "heightInches",
                    modelValue: profile.value.heightInches,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((profile.value.heightInches) = $event)),
                    options: heightInchesOptions.value,
                    name: "heightInches"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, [
                    _cache[11] || (_cache[11] = _createTextVNode("Playing Age ")),
                    _createVNode(_unref(SparklesIcon), { class: "inline w-4 h-4 mx-1 text-powder-600" })
                  ]),
                  _createVNode(SaCombobox, {
                    id: "ageRange",
                    modelValue: profile.value.ageRange,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((profile.value.ageRange) = $event)),
                    options: profile.value.ageRangeOptions,
                    name: "ageRange",
                    class: "capitalize"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", {
                    class: "block text-sm font-medium text-gray-700",
                    for: "bodyType"
                  }, "Body Type", -1)),
                  _createVNode(SaCombobox, {
                    id: "bodyType",
                    modelValue: profile.value.bodyType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((profile.value.bodyType) = $event)),
                    options: profile.value.bodyTypeOptions,
                    name: "bodyType"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", {
                    class: "block text-sm font-medium text-gray-700",
                    for: "eyes"
                  }, "Eyes", -1)),
                  _createVNode(SaCombobox, {
                    id: "eyes",
                    modelValue: profile.value.eyes,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((profile.value.eyes) = $event)),
                    options: profile.value.eyesOptions,
                    name: "eyes"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", {
                    class: "block text-sm font-medium text-gray-700",
                    for: "hair"
                  }, "Hair", -1)),
                  _createVNode(SaCombobox, {
                    id: "hair",
                    modelValue: profile.value.hair,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((profile.value.hair) = $event)),
                    options: profile.value.hairOptions,
                    name: "hair"
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h2", _hoisted_16, [
                _cache[15] || (_cache[15] = _createTextVNode("Ethnicity (check all that apply) ")),
                _createVNode(_unref(SparklesIcon), { class: "inline w-4 h-4 mx-1 text-powder-600" })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("fieldset", _hoisted_19, [
                    _cache[17] || (_cache[17] = _createElementVNode("legend", { class: "sr-only" }, "Ethnicity select", -1)),
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.value.ethnicityOptions, (option) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              id: option,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((profile.value.ethnicity) = $event)),
                              name: option,
                              value: option,
                              "aria-describedby": "",
                              class: "w-4 h-4 border-clay-500 rounded text-powder-600 focus:ring-powder-500",
                              type: "checkbox"
                            }, null, 8, _hoisted_23), [
                              [_vModelCheckbox, profile.value.ethnicity]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("label", {
                              for: option,
                              class: "font-medium text-gray-700"
                            }, _toDisplayString(option), 9, _hoisted_25),
                            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-clay-800" }, null, -1))
                          ])
                        ]))
                      }), 256))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(SaButton, {
              onClick: _withModifiers(submit, ["prevent"]),
              loading: isSubmitting.value,
              variant: "primary"
            }, {
              loading: _withCtx(() => _cache[18] || (_cache[18] = [
                _createElementVNode("span", null, "Processing...", -1)
              ])),
              _: 1
            }, 8, ["loading"])
          ])
        ])),
    _createVNode(NotificationSuccess, {
      show: updateSuccessful.value,
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})